import { useLocation } from 'react-router-dom';
import { Group } from '@mantine/core';

// Components
import PostLoginNavbarLogo from './PostLoginNavbarLogo';
import PostLoginNavbarNavLinks from './PostLoginNavbarNavLinks';
import PostLoginNavbarBackButton from './PostLoginNavbarBackButton';
import PostLoginNavbarDropdownMenu from './PostLoginNavbarDropdownMenu';

// Const
import { NAV_LINKS, NAV_HIDING_LINKS } from './postLoginConsts';

const PostLoginLayoutNavbar = () => {
  const { pathname } = useLocation();

  const shouldRenderLinks = [...NAV_LINKS, ...NAV_HIDING_LINKS].some(
    ({ href }) => pathname === href,
  );

  return (
    <nav>
      <Group gap="0" justify="space-between">
        {shouldRenderLinks ? (
          <Group gap="0">
            <PostLoginNavbarLogo />
            <PostLoginNavbarNavLinks />
          </Group>
        ) : (
          <PostLoginNavbarBackButton />
        )}
        <PostLoginNavbarDropdownMenu />
      </Group>
    </nav>
  );
};

export default PostLoginLayoutNavbar;
